import { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import colors from '../../styles/colors';
import CommonWrapper from '../../components/ui_components/AdminWrapper';
import { useLoaderData } from 'react-router-dom';
import { apiListComplete, apiListArenasByPage } from '../../components/ui_components/ApiList';
import { apiDeletePpvSpecificV2 } from '../../api/ppvApi';
import { apiGetTypeMatchesGroupedByType, apiDeleteMatchV2 } from '../../api/matchApi';
import { apiListBeltsV2 } from '../../api/beltApi';
import { apiListWrestlersV2 } from '../../api/wrestlerApi';
import CreateMatchModale from '../../components/admin/PpvHandleFolder/CreateMatchModale';
import EditMatchModale from '../../components/admin/PpvHandleFolder/EditMatchModale';
import CreatePpvGeneraleModale from '../../components/admin/PpvHandleFolder/CreatePpvGeneraleModale';
import CreatePpvSpecificModale from '../../components/admin/PpvHandleFolder/CreatePpvSpecificModale';
import PpvGeneraleDetail from '../../components/admin/PpvHandleFolder/PpvGeneraleDetail';
import PpvSpecificDetail from '../../components/admin/PpvHandleFolder/PpvSpecificDetail';

const Container = styled.div`
    width: 80%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 20px;

    & h1.admin-ppv-handle-title {
        font-size: 24px;
        font-weight: 600;
        text-align: center;
        margin-bottom: 10px;
    }

    & p.admin-ppv-handle-description {
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        margin-bottom: 10px;
    }
`;

const ContainerPpvGenerale = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 5px;
    column-gap: 5px;
`;

const BoxPpvGenerale = styled.div`
    width: calc(100% / 10);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    & img.poster-ppv {
        max-width: 100%;
        width: 125px;
        height: 180px;
        object-fit: cover;
        object-position: top;
        border: 1px solid white;
    }

    & h2.name-ppv {
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        margin-top: 10px;
        text-transform: uppercase;
        letter-spacing: 2px;
        // se troppo lungo, tronco il messaggio
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
        margin: 5px 0 0 0;
        padding: 0;
    }

    &.selected img.poster-ppv {
        border: 5px solid gold;
    }

    &.selected h2.name-ppv {
        color: gold;
    }

    &:hover {
        cursor: pointer;
        transform: scale(1.05);
        transition: transform 0.3s ease-in-out;
    }
`;

const DivForButtonCreaNuovoPpvGenerale = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 20px 0;

    & button.btn-handle-crea-nuovo-ppv-generale {
        width: 300px;
        padding: 10px;
        border-radius: 5px;
        border: 1px solid white;
        background-color: ${colors.bgColorBlack2};
        color: white;
        font-size: 20px;
        text-transform: uppercase;
        cursor: pointer;
        transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;

        &:hover {
            transform: scale(1.05);
            background-color: ${colors.bgColorBlack};
        }
    }
`;

const LoadingOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 10000;
    color: white;
    font-size: 18px;
    gap: 20px;

    .spinner-border {
        width: 3rem;
        height: 3rem;
        border: 4px solid rgba(255, 255, 255, 0.3);
        border-top-color: gold;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }

    .loading-text {
        font-size: 20px;
        font-weight: 500;
        color: gold;
        text-align: center;
    }
`;

function PpvHandle() {
    const loaderData = useLoaderData() as any;
    const [listCompletePpv, setListCompletePpv] = useState<any[]>(loaderData.data || loaderData);
    const [PpvGeneraleSelected, setPpvGeneraleSelected] = useState<any>(null);
    const [PpvSpecificSelected, setPpvSpecificSelected] = useState<any>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalPpvSpecificOpen, setIsModalPpvSpecificOpen] = useState(false);
    const [isModalMatchOpen, setIsModalMatchOpen] = useState(false);
    const [editData, setEditData] = useState<any>(null);
    const [editPpvSpecificData, setEditPpvSpecificData] = useState<any>(null);
    const [editMatchData, setEditMatchData] = useState<any>(null);
    const [arenasList, setArenasList] = useState<any[]>([]);
    const [typeMatchesList, setTypeMatchesList] = useState<any>(null); // Inizializzato a null perché l'API restituisce un oggetto, non un array
    const [beltsList, setBeltsList] = useState<any[]>([]);
    const [wrestlersList, setWrestlersList] = useState<any[]>([]);
    const [isLoadingMatchData, setIsLoadingMatchData] = useState(false);
    const detailRef = useRef<any>(null);
    const specificDetailRef = useRef<any>(null);

    const handleOpenModal = () => {
        setEditData(null); // Reset edit data quando si crea un nuovo PPV
        setIsModalOpen(true);
    };

    const handleOpenEditModal = () => {
        if (PpvGeneraleSelected) {
            setEditData(PpvGeneraleSelected);
            setIsModalOpen(true);
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setEditData(null); // Reset edit data quando si chiude la modale
    };

    const fetchAllPpv = async (): Promise<any[] | null> => {
        try {
            const response = await apiListComplete() as any;
            if (!response.error) {
                const list = response.data || response;
                setListCompletePpv(list);
                return list;
            }
        } catch (error) {
            console.error('Errore nel ricaricare i PPV:', error);
        }
        return null;
    };

    const handlePpvCreated = async () => {
        const updatedList = await fetchAllPpv();

        // Se era in modalità modifica, aggiorna anche il PPV selezionato usando i dati già caricati
        if (editData && PpvGeneraleSelected && updatedList) {
            const updatedPpv = updatedList.find((ppv: any) => ppv.id === editData.id);
            if (updatedPpv) {
                setPpvGeneraleSelected(updatedPpv);
            }
        }

        // Chiudi la modale dopo un breve delay per mostrare il messaggio di successo
        setTimeout(() => {
            setIsModalOpen(false);
            setEditData(null);
        }, 1500);
    };

    const handlePpvDeleted = async () => {
        // Ricarica i dati dopo l'eliminazione
        await fetchAllPpv();
        // Deseleziona il PPV eliminato
        setPpvGeneraleSelected(null);
    };

    const handlePpvSelect = (ppv: any) => {
        setPpvGeneraleSelected(ppv);
        setPpvSpecificSelected(null); // Reset del PPV specifico quando si seleziona un nuovo PPV Generale
    };

    const handlePpvSpecificSelect = (ppvSpecific: any) => {
        setPpvSpecificSelected(ppvSpecific);
    };

    const handleOpenPpvSpecificModal = () => {
        setEditPpvSpecificData(null); // Reset edit data quando si crea un nuovo PPV
        setIsModalPpvSpecificOpen(true);
    };

    const handleOpenEditPpvSpecificModal = (ppvSpecific: any) => {
        if (ppvSpecific) {
            setEditPpvSpecificData(ppvSpecific);
            setIsModalPpvSpecificOpen(true);
        }
    };

    const handleClosePpvSpecificModal = () => {
        setIsModalPpvSpecificOpen(false);
        setEditPpvSpecificData(null); // Reset edit data quando si chiude la modale
    };

    const fetchAllArenas = async () => {
        try {
            const response = await apiListArenasByPage('all') as any;
            if (!response.error && response.data && response.data.data) {
                setArenasList(response.data.data);
            }
        } catch (error) {
            console.error('Errore nel caricare le arene:', error);
        }
    };

    const fetchAllTypeMatches = async () => {
        try {
            const response = await apiGetTypeMatchesGroupedByType() as any;
            if (response.error) {
                console.error('Errore nel caricare i type matches:', response);
                return;
            }

            // Gestisci sia il caso in cui la risposta è direttamente i dati, sia quando è wrappata in data
            const typeMatchesData = response.data || response;

            // L'API restituisce un oggetto con chiavi per tipo (es: { "fatal": [...], "five": [...] })
            // Manteniamo la struttura originale per facilitare l'accesso
            if (typeMatchesData && typeof typeMatchesData === 'object' && !Array.isArray(typeMatchesData) && Object.keys(typeMatchesData).length > 0) {
                setTypeMatchesList(typeMatchesData);
            } else {
                console.error('Type matches data non valido:', typeMatchesData);
            }
        } catch (error) {
            console.error('Errore nel caricare i type matches:', error);
        }
    };

    const fetchAllBelts = async () => {
        try {
            const response = await apiListBeltsV2() as any;
            if (!response.error && response.data) {
                setBeltsList(response.data);
            }
        } catch (error) {
            console.error('Errore nel caricare le cinture:', error);
        }
    };

    const fetchAllWrestlers = async () => {
        try {
            const response = await apiListWrestlersV2() as any;
            if (response.error) {
                console.error('Errore nel caricare i wrestlers:', response);
                return;
            }

            // Gestisci sia il caso in cui la risposta è direttamente l'array, sia quando è wrappata in data
            const wrestlersData = response.data || response;

            if (wrestlersData && Array.isArray(wrestlersData) && wrestlersData.length > 0) {
                setWrestlersList(wrestlersData);
            } else {
                console.error('Wrestlers data non valido:', wrestlersData);
            }
        } catch (error) {
            console.error('Errore nel caricare i wrestlers:', error);
        }
    };

    const handlePpvSpecificCreated = async () => {
        // Ricarica i dati dopo la creazione - una sola chiamata API
        try {
            const response = await apiListComplete() as any;
            if (!response.error) {
                const updatedList = response.data || response;
                setListCompletePpv(updatedList);

                // Aggiorna il PPV Generale selezionato per includere il nuovo PPV specifico
                if (PpvGeneraleSelected) {
                    const updatedPpv = updatedList.find((ppv: any) => ppv.id === PpvGeneraleSelected.id);
                    if (updatedPpv) {
                        setPpvGeneraleSelected(updatedPpv);
                    }
                }
            }
        } catch (error) {
            console.error('Errore nel ricaricare i PPV:', error);
        }

        // Chiudi la modale dopo un breve delay
        setTimeout(() => {
            setIsModalPpvSpecificOpen(false);
        }, 1500);
    };

    const handleEditPpvSpecific = (ppvSpecific: any) => {
        handleOpenEditPpvSpecificModal(ppvSpecific);
    };

    const handleOpenAddMatchModal = async () => {
        setEditMatchData(null); // Reset edit data quando si crea un nuovo match
        setIsLoadingMatchData(true);
        try {
            // Carica tutti i dati necessari prima di aprire la modale
            let typeMatchesData = typeMatchesList;
            let beltsData = beltsList;
            let wrestlersData = wrestlersList;

            // Carica type matches se non disponibili
            // Controlla se è null, undefined, array vuoto, o oggetto vuoto
            const shouldLoadTypeMatches = !typeMatchesData ||
                                         Array.isArray(typeMatchesData) ||
                                         (typeof typeMatchesData === 'object' && Object.keys(typeMatchesData).length === 0);

            if (shouldLoadTypeMatches) {
                console.log('Caricamento type matches...', { typeMatchesData, isArray: Array.isArray(typeMatchesData) });
                const typeMatchesResponse = await apiGetTypeMatchesGroupedByType() as any;
                console.log('Type matches response:', typeMatchesResponse);

                // Gestisci sia il caso in cui la risposta è direttamente i dati, sia quando è wrappata in data
                if (typeMatchesResponse.error) {
                    console.error('Errore nel caricare i type matches:', typeMatchesResponse);
                    alert('Errore nel caricamento dei type matches. Riprova tra qualche istante.');
                    return;
                }

                // Prova prima con response.data, poi direttamente con response
                typeMatchesData = typeMatchesResponse.data || typeMatchesResponse;

                // Verifica che typeMatchesData sia valido
                if (!typeMatchesData || (typeof typeMatchesData !== 'object') || Array.isArray(typeMatchesData) || Object.keys(typeMatchesData).length === 0) {
                    console.error('Type matches data non valido:', typeMatchesData);
                    alert('Errore: i type matches non sono stati caricati correttamente. Riprova tra qualche istante.');
                    return;
                }

                setTypeMatchesList(typeMatchesData);
                console.log('Type matches caricati:', Object.keys(typeMatchesData).length, 'tipi');
            }

            // Carica belts se non disponibili
            if (!beltsData || beltsData.length === 0) {
                console.log('Caricamento belts...');
                const beltsResponse = await apiListBeltsV2() as any;
                console.log('Belts response:', beltsResponse);

                if (beltsResponse.error) {
                    console.error('Errore nel caricare le cinture:', beltsResponse);
                    alert('Errore nel caricamento delle cinture. Riprova tra qualche istante.');
                    return;
                }

                // Prova prima con response.data, poi direttamente con response
                beltsData = beltsResponse.data || beltsResponse;

                if (!beltsData || !Array.isArray(beltsData) || beltsData.length === 0) {
                    console.error('Belts data non valido:', beltsData);
                    alert('Errore: le cinture non sono state caricate correttamente. Riprova tra qualche istante.');
                    return;
                }

                setBeltsList(beltsData);
                console.log('Belts caricate:', beltsData.length);
            }

            // Carica wrestlers se non disponibili
            if (!wrestlersData || wrestlersData.length === 0) {
                console.log('Caricamento wrestlers...');
                const wrestlersResponse = await apiListWrestlersV2() as any;
                console.log('Wrestlers response:', wrestlersResponse);

                if (wrestlersResponse.error) {
                    console.error('Errore nel caricare i wrestlers:', wrestlersResponse);
                    alert('Errore nel caricamento dei wrestlers. Riprova tra qualche istante.');
                    return;
                }

                // Prova prima con response.data, poi direttamente con response
                wrestlersData = wrestlersResponse.data || wrestlersResponse;

                if (!wrestlersData || !Array.isArray(wrestlersData) || wrestlersData.length === 0) {
                    console.error('Wrestlers data non valido:', wrestlersData);
                    alert('Errore: i wrestlers non sono stati caricati correttamente. Riprova tra qualche istante.');
                    return;
                }

                setWrestlersList(wrestlersData);
                console.log('Wrestlers caricati:', wrestlersData.length);
            }

            // Verifica che tutti i dati siano validi
            const hasTypeMatches = typeMatchesData && typeof typeMatchesData === 'object' && !Array.isArray(typeMatchesData) && Object.keys(typeMatchesData).length > 0;
            const hasBelts = beltsData && Array.isArray(beltsData) && beltsData.length > 0;
            const hasWrestlers = wrestlersData && Array.isArray(wrestlersData) && wrestlersData.length > 0;

            console.log('Verifica dati:', {
                hasTypeMatches,
                hasBelts,
                hasWrestlers,
                typeMatchesKeys: typeMatchesData ? Object.keys(typeMatchesData).length : 0,
                beltsCount: beltsData ? beltsData.length : 0,
                wrestlersCount: wrestlersData ? wrestlersData.length : 0
            });

            if (hasTypeMatches && hasBelts && hasWrestlers) {
                // Usa setTimeout per garantire che tutti gli aggiornamenti di stato siano applicati
                // prima di aprire la modale
                setTimeout(() => {
                    setIsModalMatchOpen(true);
                    setIsLoadingMatchData(false);
                }, 0);
            } else {
                console.error('Dati non validi:', {
                    hasTypeMatches,
                    hasBelts,
                    hasWrestlers,
                    typeMatchesData: typeMatchesData ? `Oggetto con ${Object.keys(typeMatchesData).length} chiavi` : 'null/undefined',
                    beltsData: beltsData ? `Array con ${beltsData.length} elementi` : 'null/undefined',
                    wrestlersData: wrestlersData ? `Array con ${wrestlersData.length} elementi` : 'null/undefined'
                });
                alert('Errore: alcuni dati non sono stati caricati correttamente. Riprova tra qualche istante.');
                setIsLoadingMatchData(false);
            }
        } catch (error) {
            console.error('Errore durante il caricamento dei dati:', error);
            alert('Errore durante il caricamento dei dati. Riprova tra qualche istante.');
            setIsLoadingMatchData(false);
        }
    };

    const handleCloseMatchModal = () => {
        setIsModalMatchOpen(false);
        setEditMatchData(null); // Reset edit data quando si chiude la modale
    };

    const handleOpenEditMatchModal = async (match: any) => {
        if (match) {
            setEditMatchData(match);
            // Carica i dati necessari prima di aprire la modale (stesso codice di handleOpenAddMatchModal)
            setIsLoadingMatchData(true);
            try {
                let typeMatchesData = typeMatchesList;
                let beltsData = beltsList;
                let wrestlersData = wrestlersList;

                const shouldLoadTypeMatches = !typeMatchesData ||
                                             Array.isArray(typeMatchesData) ||
                                             (typeof typeMatchesData === 'object' && Object.keys(typeMatchesData).length === 0);

                if (shouldLoadTypeMatches) {
                    const typeMatchesResponse = await apiGetTypeMatchesGroupedByType() as any;
                    if (typeMatchesResponse.error) {
                        console.error('Errore nel caricare i type matches:', typeMatchesResponse);
                        alert('Errore nel caricamento dei type matches. Riprova tra qualche istante.');
                        setIsLoadingMatchData(false);
                        return;
                    }
                    typeMatchesData = typeMatchesResponse.data || typeMatchesResponse;
                    if (!typeMatchesData || (typeof typeMatchesData !== 'object') || Array.isArray(typeMatchesData) || Object.keys(typeMatchesData).length === 0) {
                        console.error('Type matches data non valido:', typeMatchesData);
                        alert('Errore: i type matches non sono stati caricati correttamente. Riprova tra qualche istante.');
                        setIsLoadingMatchData(false);
                        return;
                    }
                    setTypeMatchesList(typeMatchesData);
                }

                if (!beltsData || beltsData.length === 0) {
                    const beltsResponse = await apiListBeltsV2() as any;
                    if (beltsResponse.error) {
                        console.error('Errore nel caricare le cinture:', beltsResponse);
                        alert('Errore nel caricamento delle cinture. Riprova tra qualche istante.');
                        setIsLoadingMatchData(false);
                        return;
                    }
                    beltsData = beltsResponse.data || beltsResponse;
                    if (!beltsData || !Array.isArray(beltsData) || beltsData.length === 0) {
                        console.error('Belts data non valido:', beltsData);
                        alert('Errore: le cinture non sono state caricate correttamente. Riprova tra qualche istante.');
                        setIsLoadingMatchData(false);
                        return;
                    }
                    setBeltsList(beltsData);
                }

                if (!wrestlersData || wrestlersData.length === 0) {
                    const wrestlersResponse = await apiListWrestlersV2() as any;
                    if (wrestlersResponse.error) {
                        console.error('Errore nel caricare i wrestlers:', wrestlersResponse);
                        alert('Errore nel caricamento dei wrestlers. Riprova tra qualche istante.');
                        setIsLoadingMatchData(false);
                        return;
                    }
                    wrestlersData = wrestlersResponse.data || wrestlersResponse;
                    if (!wrestlersData || !Array.isArray(wrestlersData) || wrestlersData.length === 0) {
                        console.error('Wrestlers data non valido:', wrestlersData);
                        alert('Errore: i wrestlers non sono stati caricati correttamente. Riprova tra qualche istante.');
                        setIsLoadingMatchData(false);
                        return;
                    }
                    setWrestlersList(wrestlersData);
                }

                const hasTypeMatches = typeMatchesData && typeof typeMatchesData === 'object' && !Array.isArray(typeMatchesData) && Object.keys(typeMatchesData).length > 0;
                const hasBelts = beltsData && Array.isArray(beltsData) && beltsData.length > 0;
                const hasWrestlers = wrestlersData && Array.isArray(wrestlersData) && wrestlersData.length > 0;

                if (hasTypeMatches && hasBelts && hasWrestlers) {
                    setTimeout(() => {
                        setIsModalMatchOpen(true);
                        setIsLoadingMatchData(false);
                    }, 0);
                } else {
                    console.error('Dati non validi');
                    alert('Errore: alcuni dati non sono stati caricati correttamente. Riprova tra qualche istante.');
                    setIsLoadingMatchData(false);
                }
            } catch (error) {
                console.error('Errore durante il caricamento dei dati:', error);
                alert('Errore durante il caricamento dei dati. Riprova tra qualche istante.');
                setIsLoadingMatchData(false);
            }
        }
    };

    const handleDeleteMatch = async (match: any) => {
        if (!match) return;

        // Verifica se il match ha un cambio titolo
        const hasTitleChange = match.is_nuovo_campione === 1;

        let confirmMessage = 'Sei sicuro di voler eliminare questo match?';
        if (hasTitleChange) {
            confirmMessage += '\n\nATTENZIONE: Questo match ha un cambio titolo. Il passaggio di titolo verrà rimosso.';
        }

        const confirmDelete = window.confirm(confirmMessage);
        if (!confirmDelete) return;

        try {
            const response = await apiDeleteMatchV2(match.id) as any;
            if (response.error) {
                console.error('Errore durante l\'eliminazione del match:', response.error);
                alert('Errore durante l\'eliminazione del match');
            } else {
                // Ricarica i dati dopo l'eliminazione
                await handleMatchCreated();
            }
        } catch (error) {
            console.error('Errore durante l\'eliminazione del match:', error);
            alert('Errore durante l\'eliminazione del match');
        }
    };

    const handleMatchCreated = async () => {
        // Ricarica i dati dopo la creazione del match - UNA SOLA CHIAMATA
        try {
            const response = await apiListComplete() as any;
            if (!response.error) {
                const updatedList = response.data || response;
                setListCompletePpv(updatedList);

                // Aggiorna il PPV Generale selezionato se presente
                if (PpvGeneraleSelected) {
                    const updatedPpv = updatedList.find((ppv: any) => ppv.id === PpvGeneraleSelected.id);
                    if (updatedPpv) {
                        setPpvGeneraleSelected(updatedPpv);
                        // Trova il PPV specifico aggiornato
                        if (PpvSpecificSelected && updatedPpv.ppvs) {
                            const updatedSpecific = updatedPpv.ppvs.find((ppv: any) => ppv.id === PpvSpecificSelected.id);
                            if (updatedSpecific) {
                                setPpvSpecificSelected(updatedSpecific);
                            }
                        }
                    }
                }
            }
        } catch (error) {
            console.error('Errore nel ricaricare i PPV:', error);
        }

        setTimeout(() => {
            setIsModalMatchOpen(false);
        }, 1500);
    };

    const handleDeletePpvSpecific = async (ppvSpecific: any) => {
        if (!ppvSpecific) return;

        // Verifica se ci sono fights associati
        const hasFights = ppvSpecific.fights && Array.isArray(ppvSpecific.fights) && ppvSpecific.fights.length > 0;
        if (hasFights) {
            alert('Impossibile eliminare il PPV specifico: ci sono match associati. Elimina prima tutti i match.');
            return;
        }

        const confirmDelete = window.confirm(`Sei sicuro di voler eliminare il PPV specifico?`);
        if (!confirmDelete) return;

        try {
            const response = await apiDeletePpvSpecificV2(ppvSpecific.id) as any;
            if (response.error) {
                console.error('Errore durante l\'eliminazione del PPV specifico:', response.error);
                alert('Errore durante l\'eliminazione del PPV specifico');
            } else {
                // Ricarica i dati dopo l'eliminazione
                await handlePpvSpecificCreated();
                // Deseleziona il PPV specifico eliminato
                setPpvSpecificSelected(null);
            }
        } catch (error) {
            console.error('Errore durante l\'eliminazione del PPV specifico:', error);
            alert('Errore durante l\'eliminazione del PPV specifico');
        }
    };

    // Scroll automatico al componente PpvGeneraleDetail quando viene selezionato un PPV
    useEffect(() => {
        if (PpvGeneraleSelected && detailRef.current) {
            setTimeout(() => {
                detailRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 100);
        }
    }, [PpvGeneraleSelected]);

    // Scroll automatico al componente PpvSpecificDetail quando viene selezionato un PPV specifico
    useEffect(() => {
        if (PpvSpecificSelected && specificDetailRef.current) {
            setTimeout(() => {
                specificDetailRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 100);
        }
    }, [PpvSpecificSelected]);

    return (
        <CommonWrapper className='admin-ppv-handle-common-wrapper'>
            {isLoadingMatchData && (
                <LoadingOverlay className="loading-match-data-overlay">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Caricamento...</span>
                    </div>
                    <div className="loading-text">
                        Caricamento dati necessari per creare il match...
                    </div>
                </LoadingOverlay>
            )}
            <Container className='admin-ppv-handle-container'>
                <h1 className='admin-ppv-handle-title'>Gestisci PPVs</h1>
                <p className='admin-ppv-handle-description'>
                    Prima di creare il ppv con la data specifica, bisogna selezionare il ppv generale. Esempio: <br />
                    Se volessi inserire Forumania per il 5 Aprile2026, bisogna prima selezionare Forumania e poi inserire la data specifica. <br />
                    In caso di creazione da zero di un ppv (esempio, uno chiamato Armageddon) bisogna, appunto, prima creare il ppv generale. <br/>
                    Per comodità, verranno usati i nomi Ppv Generale (es: Forumania) e Ppv Specifico (es: Forumania 2026).
                </p>

                <DivForButtonCreaNuovoPpvGenerale className='admin-ppv-handle-button-crea-nuovo-ppv-generale'>
                    <button
                        className='btn-handle-crea-nuovo-ppv-generale'
                        onClick={handleOpenModal}
                    >
                        Crea Nuovo PPV Generale
                    </button>
                </DivForButtonCreaNuovoPpvGenerale>

                <ContainerPpvGenerale className='admin-ppv-handle-container-ppv-generale'>
                    {listCompletePpv.map((ppv) => (
                        <BoxPpvGenerale
                         key={ppv.id}
                         className={`admin-ppv-handle-container-ppv-generale-item ${PpvGeneraleSelected ? PpvGeneraleSelected.id === ppv.id ? 'selected' : '' : ''}`}
                         onClick={() => handlePpvSelect(ppv)}
                        >
                            <img src={process.env.REACT_APP_STORAGE_URL + ppv.img_path} alt={ppv.img_path + "_alt"} className='poster-ppv' />
                            <h2 className='name-ppv'>{ppv.name}</h2>
                        </BoxPpvGenerale>
                    ))}
                </ContainerPpvGenerale>

                {/* Componente che mostra i dettagli del PPV Generale selezionato */}
                {PpvGeneraleSelected && (
                    <div ref={detailRef}>
                        <PpvGeneraleDetail
                            ppvGenerale={PpvGeneraleSelected}
                            onEditClick={handleOpenEditModal}
                            onDeleteClick={handlePpvDeleted}
                            onPpvSpecificSelect={handlePpvSpecificSelect}
                            onAddPpvSpecificClick={handleOpenPpvSpecificModal}
                        />
                    </div>
                )}

                {/* Componente che mostra i dettagli del PPV Specifico selezionato */}
                {PpvSpecificSelected && PpvGeneraleSelected && (
                        <PpvSpecificDetail
                            ref={specificDetailRef}
                            {...{
                                ppvSpecific: PpvSpecificSelected,
                                ppvGeneraleName: PpvGeneraleSelected.name,
                                onEditClick: handleEditPpvSpecific,
                                onDeleteClick: handleDeletePpvSpecific,
                                arenasList,
                                onArenasLoad: fetchAllArenas,
                                onAddMatchClick: handleOpenAddMatchModal,
                                onEditMatchClick: handleOpenEditMatchModal,
                                onDeleteMatchClick: handleDeleteMatch
                            } as any}
                        />
                )}

                {/* Modale che crea/modifica PpvGenerale  */}
                {isModalOpen && (
                    <CreatePpvGeneraleModale
                        closeModalClick={handleCloseModal}
                        onPpvCreated={handlePpvCreated}
                        editData={editData}
                    />
                )}

                {/* Modale che crea/modifica PpvSpecifico  */}
                {isModalPpvSpecificOpen && PpvGeneraleSelected && (
                    <CreatePpvSpecificModale
                        ppvGeneraleId={PpvGeneraleSelected.id}
                        editData={editPpvSpecificData}
                        arenasList={arenasList}
                        onArenasLoad={fetchAllArenas}
                        closeModalClick={handleClosePpvSpecificModal}
                        onPpvSpecificCreated={handlePpvSpecificCreated}
                    />
                )}

                {/* Modale che crea Match  */}
                {isModalMatchOpen && PpvSpecificSelected && PpvGeneraleSelected &&
                 typeMatchesList && typeof typeMatchesList === 'object' && !Array.isArray(typeMatchesList) && Object.keys(typeMatchesList).length > 0 &&
                 beltsList && beltsList.length > 0 &&
                 wrestlersList && wrestlersList.length > 0 && !editMatchData && (
                    <CreateMatchModale
                        ppvSpecific={PpvSpecificSelected}
                        ppvGeneraleName={PpvGeneraleSelected.name}
                        typeMatchesList={typeMatchesList}
                        onTypeMatchesLoad={fetchAllTypeMatches}
                        beltsList={beltsList}
                        onBeltsLoad={fetchAllBelts}
                        wrestlersList={wrestlersList}
                        onWrestlersLoad={fetchAllWrestlers}
                        closeModalClick={handleCloseMatchModal}
                        onMatchCreated={handleMatchCreated}
                    />
                )}

                {/* Modale che modifica Match  */}
                {isModalMatchOpen && PpvSpecificSelected && PpvGeneraleSelected &&
                 typeMatchesList && typeof typeMatchesList === 'object' && !Array.isArray(typeMatchesList) && Object.keys(typeMatchesList).length > 0 &&
                 editMatchData && (
                    <EditMatchModale
                        ppvSpecific={PpvSpecificSelected}
                        ppvGeneraleName={PpvGeneraleSelected.name}
                        typeMatchesList={typeMatchesList}
                        onTypeMatchesLoad={fetchAllTypeMatches}
                        editData={editMatchData}
                        closeModalClick={handleCloseMatchModal}
                        onMatchCreated={handleMatchCreated}
                    />
                )}
            </Container>
        </CommonWrapper>
    );
}

export default PpvHandle;
